import { createContext } from 'react';

import { ColumnInstance } from '@work4all/components';

export type IVisibleColumnsContextValue = ColumnInstance[];

export const VisibleColumnsContext = createContext<IVisibleColumnsContextValue>(
  []
);
